import { useEffect, useState, useRef, useMemo } from "react";
import axios from "../../../../axios";
import {
  errorToast,
  successToast,
  warningToast,
} from "../../../../utils/toast";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import TimerImage from "../../../../Images/timeupimage.png";
import Loding from "../../../../componant/Loader/Loding";
import { useToast } from "@chakra-ui/react";
import {
  CheckCircle,
  XCircle,
  AlertCircle,
  Clock,
  SkipForward,
  ArrowRight,
  Info,
  HelpCircle,
  Hourglass,
  CheckCheckIcon,
  Check,
  X,
  Forward,
  SkipForwardIcon,
  FastForward,
} from "lucide-react";
import { FaAngleRight } from "react-icons/fa";
import { PiClockClockwiseLight } from "react-icons/pi";
import { MdSkipNext } from "react-icons/md";
import { IoMdSkipForward } from "react-icons/io";
import {
  BsFillSkipForwardBtnFill,
  BsForwardFill,
  BsSkipForwardBtn,
  BsSkipForwardBtnFill,
} from "react-icons/bs";
import { IoPlaySkipForward, IoPlaySkipForwardSharp } from "react-icons/io5";
import { FaForward, FaForwardFast } from "react-icons/fa6";
import EngHinToggleButton from "../../../../componant/EngHinToggleButton";
import QuestionCard from "../../../../componant/questionCard/QuestionCard";
import PremiumPopup from "./PremiumPopup";

const QuestionPage = (props) => {
  const toast = useToast({ position: "top" });
  const [t, i18n] = useTranslation();
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [data, setData] = useState({});
  const [nextdata, setNextdata] = useState({});
  const [userdata, setUserdata] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [timeLeft, setTimeLeft] = useState(30);
  const [showButton, setShowButton] = useState(false);
  const [showTimerButton, setShowTimerButton] = useState(false);
  const [correctAnswer, setCorrectAnswer] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [TimeOut, setIsTimeout] = useState(false);
  const [isSubmitFilling, setIsSubmitFilling] = useState(false);
  const [isQuestionChanging, setIsQuestionChanging] = useState(false);
  const timerRef = useRef(null);
  const submitFillTimeoutRef = useRef(null);
  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [questionCount, setQuestionCount] = useState(0);
const [showPremiumPopup, setShowPremiumPopup] = useState(false);

  const [completeData, setCompleteData] = useState({
    rightCount: 0,
    wrongCount: 0,
    skipCount: 0,
  });

  const fetchData = async () => {
    setLoading(true);
    setShowTimerButton(false);

    try {
      const response = await axios.get(`getUserQuestion`);
      if (response?.data) {
        setShowTimerButton(true);
        setData(response.data.result);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);


  useEffect(() => {
    if (data && Object.keys(data).length > 0) {
      setTimerBasedOnQuesType(data.quesType);
      setIsDisabled(false);
      setIsSubmitted(false);
      setIsCorrect(false);
      setSelectedOption(null);
      setIsSubmitFilling(false);
      setCorrectAnswer("");
    }
  }, [data]);

  useEffect(() => {
    return () => {
      if (submitFillTimeoutRef.current) {
        clearTimeout(submitFillTimeoutRef.current);
      }
    };
  }, []);

useEffect(() => {
  if (data && Object.keys(data).length > 0) {
    setShowButton(false);
    setIsTimeout(false);
    setIsQuestionChanging(false); // IMPORTANT
    startTimer();
  }
}, [data]);

  const setTimerBasedOnQuesType = (quesType) => {
    if (quesType === "reasoning") {
      setTimeLeft(60); // 30
    } else if (quesType === "maths") {
      setTimeLeft(60); // 40
    } else {
      setTimeLeft(60); // 20
    }
  };

  const currentQuestion = useMemo(() => {
    if (!data || Object.keys(data).length === 0) return null;

    return {
      question: selectedLanguage === "hi" ? data.questionHin : data.question,

      options: selectedLanguage === "hi" ? data.optionsHin : data.options,

      answer: selectedLanguage === "hi" ? data.answerHin : data.answer,

      answerEng: data.answer,
      answerHin: data.answerHin,
    };
  }, [data, selectedLanguage]);

  const handleOptionChange = (event) => {
    if (isSubmitted || isQuestionChanging) return;
    setSelectedOption(event.target.value);
    setIsSubmitted(false);
  };

  const handleSubmit = async () => {
    if (isSubmitted) {
      handleNextQuestion();
      return;
    }

    if (submitFillTimeoutRef.current) {
      clearTimeout(submitFillTimeoutRef.current);
    }
    setIsSubmitFilling(true);

    if (selectedOption === null) {
      toast({
        title: "Please select an option.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      submitFillTimeoutRef.current = setTimeout(() => {
        setIsSubmitFilling(false);
      }, 700);
      return;
    }
    setShowTimerButton(false);
    const obj = {
      questionId: data._id,
      answer: selectedOption,
      type: "submit",
    };
    try {
      const res = await axios.post(`submitAnswer/`, obj);

      if (res) {
        setLoading(true);
         
        const correctAnswer = selectedLanguage === "en" ? res?.data.rightAnsEng : res?.data.rightAnsHin;
        setCorrectAnswer(correctAnswer);
       
        const isAnswerCorrect = selectedOption === correctAnswer;
       
        setIsCorrect(isAnswerCorrect);
        setIsSubmitted(true);

        if (isAnswerCorrect) {
          setCorrectAnswers(correctAnswers + 1);
        }

        setLoading(false);

        // Auto next question after 1 second
        setTimeout(() => {
          handleNextQuestion();
        }, 700);
      }
    }
     catch (error) {
      console.error("Error submitting answer:", error);
      setIsSubmitFilling(false);
    }
  };

  const handleSkip = async () => {
    if (isQuestionChanging) return;
    setShowTimerButton(false);
    const obj = {
      questionId: data._id,
      type: "skip",
    };
    try {
      const res = await axios.post(`submitAnswer/`, obj);

      // if (res) {
      //   setLoading(true);
      //   const correctAnswer =
      //     i18n.language === "hi"
      //       ? res?.data.rightAnsHin
      //       : res?.data.rightAnsEng;
      //   setCorrectAnswer(correctAnswer);
      //   const isAnswerCorrect = selectedOption === correctAnswer;
      //   setIsCorrect(isAnswerCorrect);
      //   setIsSubmitted(true);

      //   if (isAnswerCorrect) {
      //     setCorrectAnswers(correctAnswers + 1);
      //   }
      //   setLoading(false);
      // }
      handleNextQuestion();
    } catch (error) {
      console.error("Error submitting answer:", error);
    }
  };

const handleNextQuestion = async () => {
   setQuestionCount((prev) => {
    const newCount = prev + 1;
  
    if(userdata.planName==="Test"){
      if (newCount % 10 === 0) {
      setShowPremiumPopup(true);
    }
    }
    else{
      setShowPremiumPopup(false)
    }

    // if (newCount % 10 === 0) {
    //   setShowPremiumPopup(true);
    // }

    return newCount;
  });
  setShowButton(false);
  setSelectedOption(null);
  setIsTimeout(false);
  setIsSubmitted(false);
  setIsCorrect(false);
  setCorrectAnswer("");
  setIsSubmitFilling(true);
  setIsQuestionChanging(true);

  clearInterval(timerRef.current);

  await fetchData();
};

  const startTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    timerRef.current = setInterval(() => {
      setTimeLeft((prevTimeLeft) => {
        if (prevTimeLeft <= 1) {
          clearInterval(timerRef.current);
          setShowButton(true);
          setIsDisabled(true);
          setIsTimeout(true);
          return 0;
        }
        return prevTimeLeft - 1;
      });
    }, 1000);
  };

  useEffect(() => {
  if (TimeOut) {
    const timer = setTimeout(() => {
      handleCloseTimeout();
    }, 2000);

    return () => clearTimeout(timer);
  }
}, [TimeOut]);

  useEffect(() => {
    if (userdata && Object.keys(userdata).length == 0) {
      axios
        .get("me")
        .then((response) => {
          setUserdata(response?.data?.result);
        })
        .catch((err) => {
          errorToast(err?.response?.data?.Comments);
        });
    }
  }, [userdata]);

  useEffect(() => {
    axios
      .get("me")
      .then((response) => {
        const userdata = response?.data?.result;
        setCompleteData({
          rightCount: userdata?.quizStats?.totalRight,
          wrongCount: userdata?.quizStats?.totalWrong,
          skipCount: userdata?.quizStats?.totalSkipped,
        });
      })
      .catch((err) => {
        errorToast(err?.response?.data?.Comments);
      });
  }, [data]);

  const generateOptionLabel = (index) => {
    return String.fromCharCode(65 + index);
  };

  const handleCloseTimeout = () => {
    setIsTimeout(false);
    setShowButton(false);
    setSelectedOption(null);
    setIsSubmitted(false);
    setIsCorrect(false);

    handleNextQuestion(); // 👈 next question load
  };

  const getOptionState = (option) => {
    if (!isSubmitted) {
      return selectedOption === option ? "selected" : "default";
    }
    if (option === correctAnswer) return "correct";
    if (option === selectedOption && option !== correctAnswer) return "wrong";
    return "default";
  };

const renderThreeDots = () => (
  <span className="inline-flex items-center gap-1">
    <span className="h-2 w-2 rounded-full bg-purple-600 animate-bounce"></span>
    <span
      className="h-2 w-2 rounded-full bg-purple-600 animate-bounce"
      style={{ animationDelay: "0.02s" }}
    ></span>
    <span
      className="h-2 w-2 rounded-full bg-purple-600 animate-bounce"
      style={{ animationDelay: "0.04s" }}
    ></span>
  </span>
);

  const renderSubmitButton = (className = "") => {
    const showFill = isSubmitFilling || isSubmitted || isQuestionChanging;

    return (
      <button
        onClick={handleSubmit}
        disabled={isQuestionChanging}
        className={`relative overflow-hidden text-white py-4 rounded-full text-lg font-semibold shadow-lg transition-all duration-200 active:scale-[0.98] disabled:cursor-not-allowed relative overflow-hidden
bg-bgBlue
hover:scale-[1.02]
transition-all duration-300
shadow-lg ${className}`}
      >
        <span
          className={`absolute inset-[10px] origin-left rounded-full bg-[#6B4BA3] transition-transform duration-700 ease-out ${
            showFill ? "scale-x-100" : "scale-x-0"
          }`}
        />
        <span className="relative z-10 flex min-h-[28px] items-center justify-center">
          {isQuestionChanging
            ? renderThreeDots()
            : isSubmitted
              ? "Next"
              : "Submit"}
        </span>
      </button>
    );
  };

  const renderQuestion = () => {
    return (
      <>
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <Loding />
          </div>
        ) : (
          <div className="animate-fade-in-up relative">
            {/* Watermark Overlay */}
            <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden flex items-center justify-center opacity-[0.03]">
              <div className="transform -rotate-45 text-5xl md:text-7xl font-black text-white whitespace-nowrap select-none">
                Adhyayi Adhyayi
                <br />
                Adhyayi Adhyayi
                <br />
                Adhyayi Adhyayi
                <br />
                Adhyayi Adhyayi
              </div>
            </div>

            {/* Question Card */}
            <div className="bg-white/5 rounded-2xl p-4 mb-2 border border-white/10 relative z-10">
              <span className="text-gray-400 text-sm font-semibold uppercase tracking-wider mb-2 block">
                Question
              </span>
              {currentQuestion && (
                <h2 className="text-lg md:text-lg text-white font-bold leading-relaxed relative z-10">
                  {currentQuestion?.question}
                </h2>
              )}
            </div>

            {/* Options Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
              {currentQuestion?.options?.map((option, index) => (
                <div
                  key={index}
                  className={`relative group cursor-pointer bg-white/5 rounded-xl p-2 transition-all duration-300 border-2 transform hover:scale-[1.02] overflow-hidden
                    ${
                      selectedOption === option && isSubmitted
                        ? isCorrect
                          ? "bg-green-500/20 border-green-500"
                          : "bg-red-500/20 border-red-500"
                        : selectedOption === option
                          ? "bg-purple-600/20 border-purple-500"
                          : "bg-purple-200 border-white/10 hover:bg-white/10 hover:border-purple-500/50"
                    }`}
                  onClick={() =>
                    !isSubmitted &&
                    handleOptionChange({ target: { value: option } })
                  }
                >
                  {/* Small Watermark in options */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-[0.02] pointer-events-none">
                    <span className="transform -rotate-12 text-2xl font-black text-white">
                      Adhyayi
                    </span>
                  </div>

                  <div className="flex items-center gap-4 relative z-10">
                    <div
                      className={`w-10 h-10 flex items-center justify-center rounded-lg font-bold text-lg transition-colors ${
                        selectedOption === option
                          ? "bg-purple-500 text-white"
                          : "bg-white/10 text-gray-400 group-hover:bg-white/20 group-hover:text-white"
                      }`}
                    >
                      {generateOptionLabel(index)}
                    </div>
                    <span className="text-base md:text-lg text-white font-medium flex-1">
                      {option}
                    </span>
                    {selectedOption === option && isSubmitted && (
                      <div className="animate-scale-in">
                        {isCorrect ? (
                          <CheckCircle className="text-green-500" size={20} />
                        ) : (
                          <XCircle className="text-red-500" size={20} />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </>
    );
  };

  return (
    <div className="h-screen overflow-hidden bg-gray-100 relative lg:pt-10 flex flex-col">
      {/* Background Circles */}
      <div className="absolute -top-16 -left-20 w-[300px] h-[300px] bg-[#8E7C9F] rounded-full z-0"></div>
      <div className="absolute -bottom-16 -right-20 w-[260px] h-[260px] bg-orange-300 rounded-full -z-10"></div>

      {/*DESKTOP HEADER */}
     <div className="hidden lg:flex justify-between items-center px-4 pt-6">

    {/* Help */}
    <div className="justify-between items-center z-10">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-white shadow">
        <HelpCircle className="text-purple-400" />
      </div>
    </div>

    {/* Stats */}
    <div className="flex justify-center">
      <div className="flex gap-4 rounded-2xl bg-purple-100 px-4 py-3 shadow">
        <div className="flex items-center gap-2">
          <Check
            className="rounded-full bg-green-100 p-1 text-green-500"
            size={24}
          />
          <span>{completeData.rightCount}</span>
        </div>

        <div className="flex items-center gap-2">
          <X
            className="rounded-full bg-red-100 p-1 text-red-500"
            size={24}
          />
          <span>{completeData.wrongCount}</span>
        </div>

        <div className="flex items-center gap-2">
          <FaForward
            className="rounded-full bg-yellow-100 p-1 text-yellow-400"
            size={20}
          />
          <span>{completeData.skipCount}</span>
        </div>
      </div>
    </div>

    {/* Language Toggle */}
    <div className="flex justify-start">
      <EngHinToggleButton
        selectedLanguage={selectedLanguage}
        onLanguageChange={setSelectedLanguage}
        submitText="Finish Quiz"
      />
    </div>

    {/* Timer */}
    <div className="flex justify-center lg:justify-end">
      <div className="flex items-center gap-2 rounded-full bg-yellow-100 px-3 py-2 shadow">
        <Clock className="text-orange-500" size={16} />

       <div className="h-10 w-10">
  <CircularProgressbar
    value={(timeLeft / 60) * 100}
    text={`${timeLeft}`}
    styles={buildStyles({
      pathColor: timeLeft <= 10 ? "#EF4444" : "#22C55E", // red : green
      textColor: timeLeft <= 10 ? "#EF4444" : "black",
      trailColor: "#eee",
    })}
  />
</div>
      </div>
    </div>

 
</div>
{/* Mobile Header */}
<div className="lg:hidden px-4 pt-6 z-10">
  {/* Screenshot wala layout */}
  <div className="flex items-center justify-between">

    {/* Language */}
    <EngHinToggleButton
      selectedLanguage={selectedLanguage}
      onLanguageChange={setSelectedLanguage}
    />

    {/* Timer */}
    <div className="flex items-center gap-2 rounded-2xl bg-yellow-50 px-3 py-2">
      <Clock size={16} className="text-orange-500" />
      <div className="h-12 w-12">
        <CircularProgressbar
          value={(timeLeft / 60) * 100}
          text={`${timeLeft}`}
          fontSize="32px"
        />
      </div>
    </div>
  </div>

  {/* Stats Row */}
  <div className="mt-4 rounded-3xl bg-purple-100 px-4 py-3 shadow">
    <div className="flex items-center gap-6">
      <div className="flex items-center gap-2">
        <Check className="rounded-full bg-green-100 p-1 text-green-500" />
        <span>{completeData.rightCount}</span>
      </div>

      <div className="flex items-center gap-2">
        <X className="rounded-full bg-red-100 p-1 text-red-500" />
        <span>{completeData.wrongCount}</span>
      </div>

      <div className="flex items-center gap-2">
        <FaForward className="rounded-full bg-yellow-100 p-1 text-yellow-500" />
        <span>{completeData.skipCount}</span>
      </div>
    </div>
  </div>
</div>
      {isQuestionChanging ? (
        <div className="relative z-10 mt-10 mx-4 min-h-[320px] rounded-2xl shadow flex flex-col items-center justify-center gap-3">
          <div className="flex h-14 w-24 items-center justify-center rounded-full">
            {renderThreeDots()}
          </div>
        </div>
      ) : (
        <>
          <div className="px-4 pt-4 pb-3 z-10">
  <div className="mx-auto max-w-4xl">
    <QuestionCard
      question={currentQuestion?.question}
      options={currentQuestion?.options}
      selectedOption={selectedOption}
      isSubmitted={isSubmitted}
      isQuestionChanging={isQuestionChanging}
      getOptionState={getOptionState}
      onOptionSelect={(option) =>
        handleOptionChange({
          target: { value: option },
        })
      }
    />
  </div>
</div>
        </>
      )}

      
    {/* MOBILE VIEW */}
<div className="block lg:hidden">
  {/* Skip */}
  <div className="relative z-10 px-4 mt-2">
    <button
      onClick={handleSkip}
      disabled={isQuestionChanging}
      className="bg-white px-6 py-3 rounded-xl shadow text-[#F5A623] font-medium flex items-center gap-2"
    >
      Skip
      <FaAngleRight size={16} />
    </button>
  </div>

  {/* Fixed Submit Button */}
  <div className="fixed bottom-0 left-0 right-0 p-4 z-50">
    {renderSubmitButton("w-full")}
  </div>
</div>

      {/* DESKTOP VIEW */}
      <div className="hidden lg:flex items-center pt-10 justify-center gap-4 py-4 px-4">
        {/* Submit */}
        <div className="w-[420px]">{renderSubmitButton("w-full")}</div>

        {/* Skip */}
        <button
          onClick={handleSkip}
          disabled={isQuestionChanging}
          className="h-[56px] min-w-[130px] rounded-xl bg-white shadow text-[#F5A623] font-medium flex items-center justify-center gap-2 transition-all duration-200 active:scale-95 disabled:cursor-not-allowed disabled:opacity-70"
        >
          Skip
          <FaAngleRight size={16} className="animate-slide-x" />
        </button>
      </div>

      {TimeOut && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Blur Background (CLICKABLE) */}
          <div
            className="absolute inset-0 bg-black/40 backdrop-blur-sm"
            onClick={handleCloseTimeout}
          ></div>

          {/* Modal (STOP PROPAGATION) */}
          <div
            className="relative z-10 bg-[#EC2121] text-white rounded-2xl p-6 w-[85%] max-w-sm text-center shadow-2xl animate-scale-in"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Icon */}   
            <div className="flex justify-center mb-3">
              <Hourglass
                size={60}
                className="text-[#EC2121] bg-red-500 p-2 rounded-full"
              />
            </div>
            <p className="font-bold text-white">Time's up!</p>
          </div>
        </div>
      )}
  {showPremiumPopup && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
    <PremiumPopup
      onClose={() => setShowPremiumPopup(false)}
    />
  </div>
)}
    </div>
  );
};

export default QuestionPage;
